import Divider from "../divider";
import Flex from "../flex";
import Text from "../text";
import React from "react";

interface Option {
  icon?: React.ElementType;
  title: string;
  type?: string;
  onClick?: () => void;
}

const Options = ({ options = [] }: { options: (Option | any)[] }) => {
  return (
    <div>
      {React.Children.toArray(
        options
          .filter(
            (option): option is Option => typeof option === "object" && !!option
          )
          .map((_, index) => (
            <React.Fragment>
              {!!index && <Divider className="m-0" />}
              <Flex
                gap={"1.2rem"}
                onClick={_.onClick}
                className="p-24-h p-20-v cursor-pointer"
              >
                {!!_.icon && (
                  <Text
                    level={4}
                    children={<_.icon />}
                    type={(_.type as any) || "secondary"}
                  />
                )}
                <Text
                  level={5}
                  children={_.title}
                  type={(_.type as any) || "secondary"}
                />
              </Flex>
            </React.Fragment>
          ))
      )}
    </div>
  );
};

export default Options;
